export class ClassificacaoFinanceiraEntity {
  ativado = true;
  nome = null;
  tipo = null;

  constructor(classificacaoFinanceira) {
    this.nome = classificacaoFinanceira.nome;
    if (classificacaoFinanceira.ativado == false) {
      this.ativado = false;
    }
    this.tipo = classificacaoFinanceira.tipo;
  }
}
